import { CAMPAIGNS_API_BASE_PATH } from 'modules/campaigns/api/constants'

export const SENDER_EMAIL_VALID_LIST = `${CAMPAIGNS_API_BASE_PATH}/sender-email/valid-list`
